import { actions } from "@/redux/reducers/TableFilter";
import { useDispatch } from "react-redux";

/**
 * @param key store key to clear
 * @returns clearFilterStateStore function to clear the filter state for the given key
 */
export const useClearFilterStateStore = (key?: string) => {
	const dispatch = useDispatch();

	return {
		clearFilterStateStore: (innerKey?: string) => {
			const usedKey = innerKey ?? key;
			if (!usedKey) {
				return;
			}
			dispatch(actions.DELETE_SINGLE_FILTER(usedKey));
		},
	};
};
